import { render, staticRenderFns } from "./SRichTextEditor.vue?vue&type=template&id=344fe818&lang=pug"
import script from "./SRichTextEditor.vue?vue&type=script&setup=true&lang=ts"
export * from "./SRichTextEditor.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports